import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { EntityColumnMappingSchema } from '../core/entityColumnMapping.js';
import { FeatureType } from '../core/types.js';
const SmartRouting = { id: 7, name: 'Smart Routing' };
export const smartRoutingEnabled = defineFeature({
    type: FeatureType.Boolean,
    propName: 'smart_routing_enabled',
    uiName: 'smartRoutingEnabled',
    displayName: 'Smart Routing Enabled',
    description: 'Enables smart routing agent workflow',
    category: SmartRouting,
    areas: ['agent'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
    surfacedIn: ['agent'],
});
export const smartRoutingOpensearchIndex = defineFeature({
    type: FeatureType.Json,
    propName: 'smart_routing_opensearch_index',
    uiName: 'smartRoutingOpensearchIndex',
    displayName: 'Entities OpenSearch',
    description: 'OpenSearch data connection and entities index (HCPs and accounts) used for smart routing, HCP search and HCP profiles',
    category: SmartRouting,
    areas: ['brand'],
    codec: 'json-string',
    schema: z.object({
        connectionIdentifier: z.string().nullable(),
        searchIndex: z.string(),
    }),
    default: {
        connectionIdentifier: null,
        searchIndex: '',
    },
    isSystem: true,
    surfacedIn: ['brand'],
    editor: 'hcp-opensearch-config',
});
export const smartRoutingEligibleEntities = defineFeature({
    type: FeatureType.MultiSelect,
    propName: 'smart_routing_eligible_entities',
    uiName: 'smartRoutingEligibleEntities',
    displayName: 'Smart Routing Eligible Entities',
    description: 'Entities eligible for smart routing',
    category: SmartRouting,
    areas: ['agent'],
    codec: 'identity',
    schema: z.array(z.string()).min(1),
    default: ['hcp'],
    validValues: ['hcp', 'account'],
    options: {
        hcp: { displayName: 'HCP' },
        account: { displayName: 'Account' },
    },
    isSystem: true,
    surfacedIn: ['agent'],
});
const SmartRoutingCustomColumnsSchema = z.array(EntityColumnMappingSchema);
export const smartRoutingCustomColumns = defineFeature({
    type: FeatureType.Json,
    propName: 'smart_routing_custom_columns',
    uiName: 'smartRoutingCustomColumns',
    displayName: 'Smart Routing Custom Columns',
    description: "Additional table columns mapped to fields in the brand's Entities OpenSearch index. Not applied to the legacy HCP index fallback.",
    category: SmartRouting,
    areas: ['brand'],
    codec: 'json-string',
    schema: SmartRoutingCustomColumnsSchema,
    default: [],
    isSystem: true,
    editor: 'entity-column-mappings',
    surfacedIn: ['brand'],
});
export const smartRoutingFeatures = [
    smartRoutingEnabled,
    smartRoutingOpensearchIndex,
    smartRoutingEligibleEntities,
    smartRoutingCustomColumns,
];
